import { _isMobile } from '@/utils'

(function () {
  var b = document.documentElement
  // console.log('bbbbbbbbbbbbbbbbbbbbbbbbbbbbbb', b)
  var a = function () {
    var a = b.getBoundingClientRect().width
    const tempWidth = _isMobile() ? 750 : 1920
    b.style.fontSize = (100 / tempWidth) * (a >= tempWidth ? tempWidth : a) + 'px'
  }; var c = null
  window.addEventListener('resize', function () {
    clearTimeout(c)
    c = setTimeout(a, 300)
  })
  a()
})()
